export const enum Roles {
  OnboardingUser = 'onboarding-user',
  DashboardUser = 'dashboard-user',
  RemoteCollectionUser = 'remote-collection-user',
  DataCollectorUser = 'data-collector-user'
}
